import React, { useEffect, useState, useContext } from 'react'
import { WebsocketContext } from '../contexts'
import { IWebsocketState } from '../contexts/websocket/websocketReducer'

interface IUseActionProps {
  action: [string | string[], React.Dispatch<React.SetStateAction<string | string[]>>]
  setAction: React.Dispatch<React.SetStateAction<string | string[]>>
}
type UseActionProps = IUseActionProps

export const useAction = (actions: string | string[], callback: () => void): UseActionProps => {
  const { websocketState } = useContext(WebsocketContext)
  const [message, setMessage] = useState<IWebsocketState>(websocketState)
  const [action, setAction] = useState<string | string[]>(actions)

  useEffect(() => {
    return () => {
      setMessage(null)
    }
  }, [])

  useEffect(() => {
    // console.log('action websocketState: ', websocketState)
    setMessage({ ...websocketState })
  }, [websocketState.key])

  useEffect(() => {
    // !!message && console.log('action: ' + message.key)
    if (!!message && !!message.message &&
      !!callback &&
      !!action &&
      action.length > 0) {
      let isAction = false
      if (Array.isArray(action)) {
        action.forEach(a => {
          if (a === message.message) {
            isAction = true
          }
        })
      } else {
        if (action === message.message) {
          isAction = true
        }
      }
      if (isAction) {
        callback()
      }
    }
  }, [message])

  return {
    action: [action, setAction],
    setAction
  }
}
